import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { OrderStep } from 'app/pages/order/redux/model/order-step';
import { selectAccounts, selectSelectedAccount } from 'app/pages/order/redux/order-selector';
import { ChooseContainer } from 'app/components/choose-container';
import { i18n } from 'app/i18n';
import { Spinner } from 'app/components/spinner';
import { selectAccountActionCreator } from 'app/pages/order/redux/action-creators/select-account-action-creator';
import { useAppDispatch } from 'app/hooks/thunk-hooks';
import { useGoToStep } from 'app/hooks/use-go-to-step';

import { ChooseAccountButton } from './choose-account-button';

export const ChooseAccountContent = () => {
    const accounts = useSelector(selectAccounts);
    const selectedAccount = useSelector(selectSelectedAccount);
    const dispatch = useAppDispatch();
    const goToStep = useGoToStep();

    useEffect(() => {
        if (accounts.length === 1) {
            if (!selectedAccount) {
                dispatch(selectAccountActionCreator(accounts[0]));
            }
            goToStep(OrderStep.CHOOSE_SERVICE_LOCATION, true);
        }
    }, [accounts, dispatch, goToStep, selectedAccount]);

    if (accounts.length === 1) {
        return <Spinner />;
    }

    return (
        <ChooseContainer title={i18n.page.chooseAccount.title} subTitle={i18n.page.chooseAccount.subtitle}>
            {accounts.map((account) => (
                <ChooseAccountButton key={account.customerId} account={account} />
            ))}
        </ChooseContainer>
    );
};
